import type { ExamFormTestProm, Question } from "@rmh/defs";
import { Prom, TestKey } from "@rmh/defs";
import { defaults, PROM_TEST_TITLE_PREFIX } from "./defaults";
import { oswestryEn } from "./en/oswestry";
import { oswestryEs } from "./es/oswestry";

const createProm = (locale: string): ExamFormTestProm => {
  const translations = locale === "es" ? oswestryEs : oswestryEn;

  return {
    promName: "oswestry",
    promBodyRegion: Prom.Oswestry,
    redToGreen: false,
    startAt: 0,
    updatedAt: new Date().toISOString(),
    testKey: TestKey.Oswestry,
    testTitle: `${PROM_TEST_TITLE_PREFIX} - oswestry`,
    questions: translations.questions,
  };
};

export const oswestryProm = {
  ...defaults,
  examFormTests: [
    {
      __typename: "ExamFormTestProm",
      ...createProm("en"), // Default to English
    },
  ],
};

export const getOswestryProm = (locale: string = "en") => {
  return {
    ...defaults,
    examFormTests: [
      {
        __typename: "ExamFormTestProm",
        ...createProm(locale),
      },
    ],
  };
};

export const oswestryCalculations = (questions: Question[]) => {
  const sum = questions.reduce((reducer, question) => {
    const score = question.userAnswer ?? 0;

    return score + reducer;
  }, 0);

  return (sum / 50) * 100;
};
